export const glossaryGroups = [
  {
    id: 'basics',
    label: 'คำศัพท์พื้นฐาน',
    desc: 'คำที่ต้องรู้ก่อนเริ่มเทรด Forex',
    icon: 'ri-book-2-line',
  },
  {
    id: 'orders',
    label: 'การเปิดออเดอร์',
    desc: 'คำสั่งและจุดสำคัญในการเทรด',
    icon: 'ri-send-plane-line',
  },
  {
    id: 'analysis',
    label: 'การวิเคราะห์กราฟ',
    desc: 'เครื่องมืออ่านทิศทางราคา',
    icon: 'ri-bar-chart-2-line',
  },
  {
    id: 'risk',
    label: 'การบริหารความเสี่ยง',
    desc: 'คำศัพท์ที่ช่วยให้พอร์ตอยู่รอด',
    icon: 'ri-shield-check-line',
  },
];

export const glossaryTerms = [
  {
    id: 'forex',
    term: 'Forex',
    thai: 'ตลาดแลกเปลี่ยนเงินตรา',
    group: 'basics',
    definition:
      'ตลาดที่ซื้อขายสกุลเงินต่างประเทศในรูปแบบคู่เงิน เป็นตลาดการเงินที่ใหญ่ที่สุดในโลกและเปิดซื้อขาย 24 ชั่วโมง 5 วันต่อสัปดาห์',
    example: 'ตัวอย่าง: EUR/USD คือการเทียบมูลค่ายูโรกับดอลลาร์สหรัฐ',
    articleSlug: 'what-is-forex',
  },
  {
    id: 'currency-pair',
    term: 'Currency Pair',
    thai: 'คู่เงิน',
    group: 'basics',
    definition:
      'การซื้อขาย Forex อยู่ในรูปคู่เงินเสมอ โดยสกุลเงินตัวหน้าเรียกว่าสกุลเงินฐาน และตัวหลังเรียกว่าสกุลเงินอ้างอิง',
    example: 'ตัวอย่าง: EUR/USD ที่ราคา 1.0850 หมายความว่า 1 ยูโรแลกได้ 1.0850 ดอลลาร์สหรัฐ',
    articleSlug: 'currency-pairs',
  },
  {
    id: 'pip',
    term: 'Pip',
    thai: 'หน่วยการเคลื่อนไหวของราคา',
    group: 'basics',
    definition:
      'หน่วยมาตรฐานที่ใช้วัดว่าราคาเคลื่อนไหวไปเท่าไร สำหรับคู่เงินส่วนใหญ่ Pip คือทศนิยมตำแหน่งที่ 4 ส่วนคู่เงิน JPY อยู่ที่ตำแหน่งที่ 2',
    example: 'ตัวอย่าง: EUR/USD เคลื่อนจาก 1.0842 เป็น 1.0843 = 1 Pip',
    articleSlug: 'what-is-pip',
  },
  {
    id: 'pipette',
    term: 'Pipette (Point)',
    thai: 'จุดย่อยของ Pip',
    group: 'basics',
    definition:
      'ทศนิยมตำแหน่งที่ 5 ซึ่งมีค่าเท่ากับหนึ่งในสิบของ Pip ใช้แสดงความละเอียดของราคาที่แพลตฟอร์มเทรดสมัยใหม่',
    example: 'ตัวอย่าง: EUR/USD 1.08421 → 1.08422 = 1 Pipette หรือ 0.1 Pip',
    articleSlug: 'what-is-pip',
  },
  {
    id: 'bid',
    term: 'Bid',
    thai: 'ราคาเสนอซื้อ',
    group: 'basics',
    definition:
      'ราคาที่โบรกเกอร์ยอมซื้อคู่เงินจากเรา ใช้เมื่อเราต้องการส่งคำสั่ง Sell โดย Bid จะต่ำกว่า Ask เสมอ',
    example: 'ตัวอย่าง: ถ้า Bid แสดง 1.0848 การกด Sell จะได้ราคานี้ทันที',
    articleSlug: 'what-is-spread',
  },
  {
    id: 'ask',
    term: 'Ask',
    thai: 'ราคาเสนอขาย',
    group: 'basics',
    definition:
      'ราคาที่โบรกเกอร์ขายคู่เงินให้เรา ใช้เมื่อเราต้องการส่งคำสั่ง Buy โดย Ask จะสูงกว่า Bid เสมอ',
    example: 'ตัวอย่าง: ถ้า Ask แสดง 1.0850 การกด Buy จะได้ราคานี้ทันที',
    articleSlug: 'what-is-spread',
  },
  {
    id: 'spread',
    term: 'Spread',
    thai: 'ส่วนต่างราคา Bid–Ask',
    group: 'basics',
    definition:
      'ผลต่างระหว่างราคา Ask และ Bid ซึ่งเป็นต้นทุนแฝงที่เทรดเดอร์จ่ายทุกครั้งที่เปิดออเดอร์ ยิ่ง Spread กว้าง ราคาต้องเคลื่อนที่มากกว่าเดิมเพื่อเริ่มกำไร',
    example: 'ตัวอย่าง: Ask 1.0850 และ Bid 1.0848 = Spread 2 Pip',
    articleSlug: 'what-is-spread',
  },
  {
    id: 'leverage',
    term: 'Leverage',
    thai: 'อัตราทด',
    group: 'basics',
    definition:
      'อัตราส่วนที่ช่วยให้คุมขนาดสถานะได้ใหญ่กว่าทุนที่มี เช่น 1:100 หมายถึงวางเงินประกัน 1% ของขนาดสถานะ Leverage ขยายทั้งกำไรและความเสี่ยง',
    example: 'ตัวอย่าง: Leverage 1:100 ใช้เงิน 100 ดอลลาร์คุมสถานะได้ 10,000 ดอลลาร์',
    articleSlug: 'what-is-leverage',
  },
  {
    id: 'margin',
    term: 'Margin',
    thai: 'เงินประกันการเปิดสถานะ',
    group: 'basics',
    definition:
      'จำนวนเงินขั้นต่ำที่ถูกกันไว้จากพอร์ตเพื่อค้ำประกันสถานะที่เปิดอยู่ เป็นเงินของเราและจะคืนเมื่อปิดออเดอร์',
    example: 'ตัวอย่าง: เปิด 1 Lot EUR/USD ที่ leverage 1:100 ต้องใช้ Margin ประมาณ 1,085 ดอลลาร์ หรือ 1% ของมูลค่าสัญญา',
    articleSlug: 'what-is-margin',
  },
  {
    id: 'lot',
    term: 'Lot',
    thai: 'ขนาดสัญญา',
    group: 'basics',
    definition:
      'หน่วยมาตรฐานที่ใช้วัดขนาดของออเดอร์ โดย 1 Standard Lot เท่ากับ 100,000 หน่วยของสกุลเงินฐาน ยิ่ง Lot ใหญ่ ความเสี่ยงต่อ Pip ยิ่งสูง',
    example: 'ตัวอย่าง: 0.10 Lot (Mini) มีมูลค่าประมาณ 1 ดอลลาร์ต่อ Pip',
    articleSlug: 'how-to-calculate-lot',
  },
  {
    id: 'buy-long',
    term: 'Buy / Long',
    thai: 'คำสั่งซื้อคาดราคาขึ้น',
    group: 'orders',
    definition:
      'การเปิดออเดอร์โดยคาดว่าราคาจะปรับตัวขึ้น เราจะได้กำไรเมื่อราคาปิดสูงกว่าราคาเข้า',
    example: 'ตัวอย่าง: เปิด Buy EUR/USD ที่ 1.0850 แล้วปิดที่ 1.0900 = กำไร 50 Pip',
    articleSlug: 'how-to-place-order',
  },
  {
    id: 'sell-short',
    term: 'Sell / Short',
    thai: 'คำสั่งขายคาดราคาลง',
    group: 'orders',
    definition:
      'การเปิดออเดอร์โดยคาดว่าราคาจะปรับตัวลง เราจะได้กำไรเมื่อราคาปิดต่ำกว่าราคาเข้า',
    example: 'ตัวอย่าง: เปิด Sell EUR/USD ที่ 1.0900 แล้วปิดที่ 1.0850 = กำไร 50 Pip',
    articleSlug: 'how-to-place-order',
  },
  {
    id: 'stop-loss',
    term: 'Stop Loss',
    thai: 'จุดตัดขาดทุน',
    group: 'orders',
    definition:
      'คำสั่งปิดออเดอร์อัตโนมัติเมื่อราคาเดินสวนถึงระดับที่กำหนด ช่วยจำกัดความเสียหายต่อออเดอร์ให้อยู่ในกรอบที่วางแผนไว้',
    example: 'ตัวอย่าง: เปิด Buy ที่ 1.0850 ตั้ง Stop Loss ที่ 1.0825 = เสี่ยง 25 Pip',
    articleSlug: 'stop-loss-take-profit',
  },
  {
    id: 'take-profit',
    term: 'Take Profit',
    thai: 'จุดทำกำไร',
    group: 'orders',
    definition:
      'คำสั่งปิดออเดอร์อัตโนมัติเมื่อราคาไปถึงเป้าหมายที่กำหนด ช่วยล็อกกำไรตามแผนโดยไม่ต้องเฝ้าหน้าจอ',
    example: 'ตัวอย่าง: เปิด Buy ที่ 1.0850 ตั้ง Take Profit ที่ 1.0900 = เป้าหมาย 50 Pip',
    articleSlug: 'stop-loss-take-profit',
  },
  {
    id: 'pending-order',
    term: 'Pending Order',
    thai: 'คำสั่งรอราคา',
    group: 'orders',
    definition:
      'คำสั่งที่ตั้งไว้ล่วงหน้าให้ระบบเปิดออเดอร์เมื่อราคาไปแตะระดับที่กำหนด เช่น Buy Limit, Sell Limit, Buy Stop และ Sell Stop',
    example: 'ตัวอย่าง: ตั้ง Buy Limit ที่ 1.0800 เพื่อรอซื้อเมื่อราคาย่อลงมาแตะระดับนั้น',
    articleSlug: 'how-to-place-order-mt5',
  },
  {
    id: 'candlestick',
    term: 'Candlestick',
    thai: 'แท่งเทียน',
    group: 'analysis',
    definition:
      'รูปแบบกราฟที่แสดงราคาเปิด ปิด สูงสุด และต่ำสุดของช่วงเวลาหนึ่ง ช่วยให้เห็นพฤติกรรมราคาและอารมณ์ตลาดได้อย่างรวดเร็ว',
    example: 'ตัวอย่าง: แท่งเทียน 1 ชั่วโมงแสดงราคาเปิด ปิด สูงสุด และต่ำสุดของชั่วโมงนั้น',
    articleSlug: 'price-action',
  },
  {
    id: 'trend',
    term: 'Trend',
    thai: 'แนวโน้มราคา',
    group: 'analysis',
    definition:
      'ทิศทางหลักที่ราคาเคลื่อนไหว แบ่งเป็นขาขึ้น (Uptrend) ขาลง (Downtrend) และออกข้าง (Sideway) การเทรดตามแนวโน้มมักมีโอกาสสำเร็จสูงกว่า',
    example: 'ตัวอย่าง: ราคาทำจุดสูงและจุดต่ำที่สูงขึ้นเรื่อย ๆ คือขาขึ้น (Uptrend)',
    articleSlug: 'forex-technical-analysis',
  },
  {
    id: 'support',
    term: 'Support',
    thai: 'แนวรับ',
    group: 'analysis',
    definition:
      'ระดับราคาที่มีแรงซื้อเข้ามาหนุนทำให้ราคาหยุดลงหรือเด้งกลับ มักใช้เป็นจุดพิจารณาเปิด Buy',
    example: 'ตัวอย่าง: ราคาย่อลงมาแตะ 1.0800 แล้วเด้งขึ้นหลายครั้ง แสดงว่า 1.0800 เป็นแนวรับ',
    articleSlug: 'support-resistance',
  },
  {
    id: 'resistance',
    term: 'Resistance',
    thai: 'แนวต้าน',
    group: 'analysis',
    definition:
      'ระดับราคาที่มีแรงขายเข้ามากดทำให้ราคาหยุดขึ้นหรือย่อตัว มักใช้เป็นจุดพิจารณาเปิด Sell',
    example: 'ตัวอย่าง: ราคาเด้งขึ้นไปชน 1.0950 แล้วย่อลงหลายครั้ง แสดงว่า 1.0950 เป็นแนวต้าน',
    articleSlug: 'support-resistance',
  },
  {
    id: 'moving-average',
    term: 'Moving Average',
    thai: 'เส้นค่าเฉลี่ยเคลื่อนที่',
    group: 'analysis',
    definition:
      'อินดิเคเตอร์ที่เฉลี่ยราคาย้อนหลังเพื่อให้เห็นแนวโน้มชัดขึ้น เช่น MA 50 และ MA 200 ที่นิยมใช้ดูทิศทางหลักของตลาด',
    example: 'ตัวอย่าง: ราคายืนเหนือ MA 200 บนกราฟรายวันมักถูกมองเป็นภาพรวมขาขึ้น',
    articleSlug: 'technical-indicators',
  },
  {
    id: 'rsi',
    term: 'RSI',
    thai: 'ดัชนีวัดแรงซื้อขาย',
    group: 'analysis',
    definition:
      'อินดิเคเตอร์ที่วัดความแข็งแกร่งของแรงซื้อและแรงขายในช่วง 0–100 ค่าเกิน 70 มักสื่อถึงสภาวะซื้อมากเกินไป และต่ำกว่า 30 คือขายมากเกินไป',
    example: 'ตัวอย่าง: RSI เกิน 70 อาจเป็นสัญญาณว่าราคากำลังอ่อนแรง',
    articleSlug: 'technical-indicators',
  },
  {
    id: 'macd',
    term: 'MACD',
    thai: 'อินดิเคเตอร์โมเมนตัม',
    group: 'analysis',
    definition:
      'อินดิเคเตอร์ที่ดูความแตกต่างของเส้นค่าเฉลี่ยสองเส้น ช่วยจับการเปลี่ยนทิศทางของโมเมนตัมผ่านการตัดกันของเส้นสัญญาณ',
    example: 'ตัวอย่าง: เส้น MACD ตัดขึ้นเหนือเส้น Signal มักถูกมองเป็นสัญญาณโมเมนตัมขาขึ้น',
    articleSlug: 'technical-indicators',
  },
  {
    id: 'risk-per-trade',
    term: 'Risk per Trade',
    thai: 'ความเสี่ยงต่อออเดอร์',
    group: 'risk',
    definition:
      'สัดส่วนของพอร์ตที่ยอมเสียได้ในแต่ละออเดอร์ โดยทั่วไปแนะนำไม่เกิน 1–2% ของทุน เพื่อให้พอร์ตทนต่อการขาดทุนต่อเนื่องได้',
    example: 'ตัวอย่าง: พอร์ต 1,000 ดอลลาร์ เสี่ยง 1% = 10 ดอลลาร์ต่อออเดอร์',
    articleSlug: 'risk-management-basics',
  },
  {
    id: 'position-sizing',
    term: 'Position Sizing',
    thai: 'การกำหนดขนาดสถานะ',
    group: 'risk',
    definition:
      'วิธีคำนวณขนาด Lot จากความเสี่ยงที่ยอมรับได้และระยะ Stop Loss เพื่อให้แต่ละออเดอร์มีความเสี่ยงเท่ากันสม่ำเสมอ',
    example: 'ตัวอย่าง: พอร์ต 1,000 ดอลลาร์ เสี่ยง 1% (10 ดอลลาร์) ระยะ Stop Loss 20 Pip = ขนาด 0.05 Lot',
    articleSlug: 'position-sizing',
  },
  {
    id: 'risk-reward',
    term: 'Risk / Reward Ratio',
    thai: 'อัตราส่วนความเสี่ยงต่อผลตอบแทน',
    group: 'risk',
    definition:
      'การเปรียบเทียบระยะ Stop Loss กับระยะ Take Profit เช่น 1:2 หมายถึงยอมเสี่ยง 1 เพื่อโอกาสทำกำไร 2 เท่า เป็นเครื่องมือช่วยประเมินคุณภาพของออเดอร์',
    example: 'ตัวอย่าง: เสี่ยง 25 Pip เพื่อเป้าหมาย 50 Pip = Risk/Reward 1:2',
    articleSlug: 'risk-reward-ratio',
  },
  {
    id: 'drawdown',
    term: 'Drawdown',
    thai: 'การย้อนกลับของพอร์ต',
    group: 'risk',
    definition:
      'ระดับที่พอร์ตลดลงจากจุดสูงสุดที่เคยทำได้ ใช้ประเมินว่าระบบหรือวินัยการเทรดของเรารับความเสียหายได้แค่ไหน',
    example: 'ตัวอย่าง: พอร์ตขึ้นไปสูงสุด 1,200 ดอลลาร์ แล้วลดเหลือ 1,000 ดอลลาร์ = Drawdown ประมาณ 16.7%',
    articleSlug: 'drawdown',
  },
  {
    id: 'margin-call',
    term: 'Margin Call',
    thai: 'การเรียกหลักประกันเพิ่ม',
    group: 'risk',
    definition:
      'สัญญาณเตือนเมื่อ Margin Level ของพอร์ตลดต่ำกว่าเกณฑ์ที่โบรกเกอร์กำหนด ซึ่งอาจนำไปสู่การปิดออเดอร์อัตโนมัติหากไม่เติมเงินหรือลดขนาดสถานะ',
    example: 'ตัวอย่าง: เมื่อ Margin Level ลดต่ำกว่าเกณฑ์ของโบรกเกอร์ เช่น 100% จะได้แจ้งเตือน และอาจถูกปิดสถานะอัตโนมัติหากลดต่ำลงอีก',
    articleSlug: 'what-is-margin',
  },
];

export const glossaryRelated: Record<string, string[]> = {
  forex: ['currency-pair', 'pip', 'lot'],
  'currency-pair': ['forex', 'pip', 'spread'],
  pip: ['spread', 'pipette', 'lot', 'position-sizing'],
  pipette: ['pip', 'spread'],
  bid: ['ask', 'spread'],
  ask: ['bid', 'spread'],
  spread: ['pip', 'bid', 'ask'],
  leverage: ['margin', 'lot', 'margin-call'],
  margin: ['leverage', 'margin-call', 'position-sizing'],
  lot: ['pip', 'position-sizing', 'leverage'],
  'buy-long': ['sell-short', 'pending-order'],
  'sell-short': ['buy-long', 'pending-order'],
  'stop-loss': ['take-profit', 'risk-reward', 'position-sizing'],
  'take-profit': ['stop-loss', 'risk-reward'],
  'pending-order': ['buy-long', 'sell-short'],
  candlestick: ['trend', 'support', 'resistance'],
  trend: ['moving-average', 'support', 'resistance'],
  support: ['resistance', 'trend'],
  resistance: ['support', 'trend'],
  'moving-average': ['trend', 'rsi', 'macd'],
  rsi: ['macd', 'moving-average'],
  macd: ['rsi', 'moving-average'],
  'risk-per-trade': ['position-sizing', 'risk-reward', 'drawdown'],
  'position-sizing': ['risk-per-trade', 'lot', 'stop-loss'],
  'risk-reward': ['stop-loss', 'take-profit', 'risk-per-trade'],
  drawdown: ['risk-per-trade', 'margin-call'],
  'margin-call': ['margin', 'leverage', 'drawdown'],
};